import {Item, ItemSubType} from '../../generated/types';

export function getItemSubTypes(item: Item): ItemSubType[] {
	return (
		item.subType || item.baseItem?.subType || item.parentItem?.baseItem?.subType || item.parentItem?.subType || []
	);
}

export function hasOnlySubType(item: Item, subType: ItemSubType): boolean {
	const subTypes = getItemSubTypes(item);
	return subTypes.length === 1 && subTypes[0] === subType;
}
